module.exports = __webpack_public_path__ + "img/NUX_686c8e0.webp";